import type { Release } from '../releases.ts';

export default {
  version: '0.17.3',
  date: '2026-10-02',
  title: 'Transcoding layout',
  summary: [
    'Fixed: transcoding profile rows stay inside the panel; long FFmpeg options show in full on hover',
    'Fixed: the FFmpeg options box is tall enough, and can be made taller',
  ],
  features: [],
  fixes: [
    'Administration → Transcoding: profile rows stay inside the panel; long FFmpeg options are cut off with … and shown in full on hover',
    'The profile editor’s FFmpeg options box is tall enough to read and edit long options, and can be made taller',
  ],
} satisfies Release;
